'use client'
import useFlightTimingFilterManager from '@/src/hooks/srp/flightTimingFilterManager'
import { FlightTimingsFilter } from './FlightTimingsFilter'

const FlightTimingsFilterWrapper = () => {
    const { timeSlots, handleSelectToggle, handleReset, shouldShowReset, title } = useFlightTimingFilterManager()

    return (
        <FlightTimingsFilter
            flightTimings={timeSlots}
            onTimeSlotSelect={handleSelectToggle}
            onReset={handleReset}
            shouldShowReset={shouldShowReset}
            title={title}
        />
    )
}

export { FlightTimingsFilterWrapper as FlightTimingsFilter }

export default FlightTimingsFilterWrapper
